import * as actionTypes from "./SubProjectsTypes";

const INITIAL_STATE = {
    projectList: [],
    contactPersonList: [],
    subProjectList: [],
    subProjectFilterList: [],
    basicFilterData: [],
    subProjectDetail: null,
};

const SubProjectsReducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case actionTypes.SETPROJECTLIST:
            return {
                ...state,
                projectList: action.payload.list,
            };
        case actionTypes.SETCONTACTPERSONLIST:
            return {
                ...state,
                contactPersonList: action.payload.list,
            };
        case actionTypes.SETSUBPROJECTLIST:
            return {
                ...state,
                subProjectList: action.payload.list,
            };
        case actionTypes.SETSUBPROJECTFILTERLIST:
            return {
                ...state,
                subProjectFilterList: action.payload.list,
            };
        case actionTypes.SETSUBPROJECTDETAIL:
            return {
                ...state,
                subProjectDetail: action.payload.list,
            };
        case actionTypes.SETSUBPROJECTSBASICFILTERDATA:
            return {
                ...state,
                basicFilterData: { ...action.payload }
            };
        default:
            return state;
    }
};

export default SubProjectsReducer;